export const GTE = "\u2265";

export const LTE = "\u2264";
